import { gql, useMutation } from '@apollo/client'

export const UPDATE_LABEL = gql`
  mutation($input: LabelInput) {
    updateLabel(input: $input) {
      id
    }
  }
`

export const useUpdateLabel = () => {
  const [mutate, { data, loading, error }] = useMutation(UPDATE_LABEL, {
    update(cache) {
      cache.modify({
        fields: {
          getLabels() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
